<template>
  <ButtonCircle
    action="ellipsis"
    :is_disabled="loading"
    :is_subtle="subtle"
    :data-test="button_data_test"
    @onClick="togglePopover"
  />

  <Popover
    ref="popover"
    :pt="{ content: '!p-0 !m-0' }"
    @show="emit('open')"
    @hide="emit('close')"
  >
    <div
      class="flex flex-col gap-1 py-1"
      @click="closePopover"
    >
      <slot />
    </div>
  </Popover>
</template>

<script setup>
import { computed, ref, useAttrs } from 'vue';
import ButtonCircle from '@/app/shared_components/buttons/ButtonCircle.vue';

defineOptions({ inheritAttrs: false });

defineProps({
  loading: { type: Boolean, default: false },
  subtle: { type: Boolean, default: false },
});

const attrs = useAttrs();
const button_data_test = computed(() => attrs['data-test'] || 'button-settings');

const emit = defineEmits(['open', 'close']);

const popover = ref(null);

const togglePopover = (event) => {
  popover.value.toggle(event);
};

const closePopover = () => {
  popover.value.hide();
};

defineExpose({ close: closePopover });
</script>
